/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TimeRouteImport } from './routes/time'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EmployeesRouteImport } from './routes/employees'
import { Route as DocumentsRouteImport } from './routes/documents'
import { Route as ClientsRouteImport } from './routes/clients'
import { Route as AelitaRouteImport } from './routes/aelita'
import { Route as InvoicesRouteRouteImport } from './routes/invoices.route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InvoicesIndexRouteImport } from './routes/invoices.index'
import { Route as TasksTaskIdRouteImport } from './routes/tasks.$taskId'
import { Route as ProjectProjectIdRouteImport } from './routes/project.$projectId'
import { Route as PaySuccessRouteImport } from './routes/pay.success'
import { Route as PayCancelledRouteImport } from './routes/pay.cancelled'
import { Route as PayTokenRouteImport } from './routes/pay.$token'
import { Route as InvoicesNewRouteImport } from './routes/invoices.new'
import { Route as InvoicesInvoiceIdRouteImport } from './routes/invoices.$invoiceId'
import { Route as EmployeeEmployeeIdRouteImport } from './routes/employee.$employeeId'
import { Route as ClientClientIdRouteImport } from './routes/client.$clientId'

const TimeRoute = TimeRouteImport.update({
  id: '/time',
  path: '/time',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesRoute = EmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsRoute = ClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const AelitaRoute = AelitaRouteImport.update({
  id: '/aelita',
  path: '/aelita',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRouteRoute = InvoicesRouteRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InvoicesRouteRoute,
} as any)
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/$taskId',
  path: '/$taskId',
  getParentRoute: () => TasksRoute,
} as any)
const ProjectProjectIdRoute = ProjectProjectIdRouteImport.update({
  id: '/project/$projectId',
  path: '/project/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const PaySuccessRoute = PaySuccessRouteImport.update({
  id: '/pay/success',
  path: '/pay/success',
  getParentRoute: () => rootRouteImport,
} as any)
const PayCancelledRoute = PayCancelledRouteImport.update({
  id: '/pay/cancelled',
  path: '/pay/cancelled',
  getParentRoute: () => rootRouteImport,
} as any)
const PayTokenRoute = PayTokenRouteImport.update({
  id: '/pay/$token',
  path: '/pay/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesNewRoute = InvoicesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => InvoicesRouteRoute,
} as any)
const InvoicesInvoiceIdRoute = InvoicesInvoiceIdRouteImport.update({
  id: '/$invoiceId',
  path: '/$invoiceId',
  getParentRoute: () => InvoicesRouteRoute,
} as any)
const EmployeeEmployeeIdRoute = EmployeeEmployeeIdRouteImport.update({
  id: '/employee/$employeeId',
  path: '/employee/$employeeId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientClientIdRoute = ClientClientIdRouteImport.update({
  id: '/client/$clientId',
  path: '/client/$clientId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/invoices': typeof InvoicesRouteRouteWithChildren
  '/aelita': typeof AelitaRoute
  '/clients': typeof ClientsRoute
  '/documents': typeof DocumentsRoute
  '/employees': typeof EmployeesRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/tasks': typeof TasksRouteWithChildren
  '/terms': typeof TermsRoute
  '/time': typeof TimeRoute
  '/client/$clientId': typeof ClientClientIdRoute
  '/employee/$employeeId': typeof EmployeeEmployeeIdRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/pay/$token': typeof PayTokenRoute
  '/pay/cancelled': typeof PayCancelledRoute
  '/pay/success': typeof PaySuccessRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/invoices/': typeof InvoicesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aelita': typeof AelitaRoute
  '/clients': typeof ClientsRoute
  '/documents': typeof DocumentsRoute
  '/employees': typeof EmployeesRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/tasks': typeof TasksRouteWithChildren
  '/terms': typeof TermsRoute
  '/time': typeof TimeRoute
  '/client/$clientId': typeof ClientClientIdRoute
  '/employee/$employeeId': typeof EmployeeEmployeeIdRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/pay/$token': typeof PayTokenRoute
  '/pay/cancelled': typeof PayCancelledRoute
  '/pay/success': typeof PaySuccessRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/invoices': typeof InvoicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/invoices': typeof InvoicesRouteRouteWithChildren
  '/aelita': typeof AelitaRoute
  '/clients': typeof ClientsRoute
  '/documents': typeof DocumentsRoute
  '/employees': typeof EmployeesRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/projects': typeof ProjectsRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/tasks': typeof TasksRouteWithChildren
  '/terms': typeof TermsRoute
  '/time': typeof TimeRoute
  '/client/$clientId': typeof ClientClientIdRoute
  '/employee/$employeeId': typeof EmployeeEmployeeIdRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/pay/$token': typeof PayTokenRoute
  '/pay/cancelled': typeof PayCancelledRoute
  '/pay/success': typeof PaySuccessRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/invoices/': typeof InvoicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invoices'
    | '/aelita'
    | '/clients'
    | '/documents'
    | '/employees'
    | '/login'
    | '/privacy'
    | '/projects'
    | '/settings'
    | '/setup'
    | '/tasks'
    | '/terms'
    | '/time'
    | '/client/$clientId'
    | '/employee/$employeeId'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/pay/$token'
    | '/pay/cancelled'
    | '/pay/success'
    | '/project/$projectId'
    | '/tasks/$taskId'
    | '/invoices/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aelita'
    | '/clients'
    | '/documents'
    | '/employees'
    | '/login'
    | '/privacy'
    | '/projects'
    | '/settings'
    | '/setup'
    | '/tasks'
    | '/terms'
    | '/time'
    | '/client/$clientId'
    | '/employee/$employeeId'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/pay/$token'
    | '/pay/cancelled'
    | '/pay/success'
    | '/project/$projectId'
    | '/tasks/$taskId'
    | '/invoices'
  id:
    | '__root__'
    | '/'
    | '/invoices'
    | '/aelita'
    | '/clients'
    | '/documents'
    | '/employees'
    | '/login'
    | '/privacy'
    | '/projects'
    | '/settings'
    | '/setup'
    | '/tasks'
    | '/terms'
    | '/time'
    | '/client/$clientId'
    | '/employee/$employeeId'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/pay/$token'
    | '/pay/cancelled'
    | '/pay/success'
    | '/project/$projectId'
    | '/tasks/$taskId'
    | '/invoices/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InvoicesRouteRoute: typeof InvoicesRouteRouteWithChildren
  AelitaRoute: typeof AelitaRoute
  ClientsRoute: typeof ClientsRoute
  DocumentsRoute: typeof DocumentsRoute
  EmployeesRoute: typeof EmployeesRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  ProjectsRoute: typeof ProjectsRoute
  SettingsRoute: typeof SettingsRoute
  SetupRoute: typeof SetupRoute
  TasksRoute: typeof TasksRouteWithChildren
  TermsRoute: typeof TermsRoute
  TimeRoute: typeof TimeRoute
  ClientClientIdRoute: typeof ClientClientIdRoute
  EmployeeEmployeeIdRoute: typeof EmployeeEmployeeIdRoute
  PayTokenRoute: typeof PayTokenRoute
  PayCancelledRoute: typeof PayCancelledRoute
  PaySuccessRoute: typeof PaySuccessRoute
  ProjectProjectIdRoute: typeof ProjectProjectIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/time': {
      id: '/time'
      path: '/time'
      fullPath: '/time'
      preLoaderRoute: typeof TimeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees': {
      id: '/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof EmployeesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients': {
      id: '/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aelita': {
      id: '/aelita'
      path: '/aelita'
      fullPath: '/aelita'
      preLoaderRoute: typeof AelitaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/': {
      id: '/invoices/'
      path: '/'
      fullPath: '/invoices/'
      preLoaderRoute: typeof InvoicesIndexRouteImport
      parentRoute: typeof InvoicesRouteRoute
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof TasksRoute
    }
    '/project/$projectId': {
      id: '/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof ProjectProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/success': {
      id: '/pay/success'
      path: '/pay/success'
      fullPath: '/pay/success'
      preLoaderRoute: typeof PaySuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/cancelled': {
      id: '/pay/cancelled'
      path: '/pay/cancelled'
      fullPath: '/pay/cancelled'
      preLoaderRoute: typeof PayCancelledRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/$token': {
      id: '/pay/$token'
      path: '/pay/$token'
      fullPath: '/pay/$token'
      preLoaderRoute: typeof PayTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/new': {
      id: '/invoices/new'
      path: '/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof InvoicesNewRouteImport
      parentRoute: typeof InvoicesRouteRoute
    }
    '/invoices/$invoiceId': {
      id: '/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof InvoicesInvoiceIdRouteImport
      parentRoute: typeof InvoicesRouteRoute
    }
    '/employee/$employeeId': {
      id: '/employee/$employeeId'
      path: '/employee/$employeeId'
      fullPath: '/employee/$employeeId'
      preLoaderRoute: typeof EmployeeEmployeeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client/$clientId': {
      id: '/client/$clientId'
      path: '/client/$clientId'
      fullPath: '/client/$clientId'
      preLoaderRoute: typeof ClientClientIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface InvoicesRouteRouteChildren {
  InvoicesInvoiceIdRoute: typeof InvoicesInvoiceIdRoute
  InvoicesNewRoute: typeof InvoicesNewRoute
  InvoicesIndexRoute: typeof InvoicesIndexRoute
}

const InvoicesRouteRouteChildren: InvoicesRouteRouteChildren = {
  InvoicesInvoiceIdRoute: InvoicesInvoiceIdRoute,
  InvoicesNewRoute: InvoicesNewRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
}

const InvoicesRouteRouteWithChildren = InvoicesRouteRoute._addFileChildren(
  InvoicesRouteRouteChildren,
)

interface TasksRouteChildren {
  TasksTaskIdRoute: typeof TasksTaskIdRoute
}

const TasksRouteChildren: TasksRouteChildren = {
  TasksTaskIdRoute: TasksTaskIdRoute,
}

const TasksRouteWithChildren = TasksRoute._addFileChildren(TasksRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InvoicesRouteRoute: InvoicesRouteRouteWithChildren,
  AelitaRoute: AelitaRoute,
  ClientsRoute: ClientsRoute,
  DocumentsRoute: DocumentsRoute,
  EmployeesRoute: EmployeesRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  ProjectsRoute: ProjectsRoute,
  SettingsRoute: SettingsRoute,
  SetupRoute: SetupRoute,
  TasksRoute: TasksRouteWithChildren,
  TermsRoute: TermsRoute,
  TimeRoute: TimeRoute,
  ClientClientIdRoute: ClientClientIdRoute,
  EmployeeEmployeeIdRoute: EmployeeEmployeeIdRoute,
  PayTokenRoute: PayTokenRoute,
  PayCancelledRoute: PayCancelledRoute,
  PaySuccessRoute: PaySuccessRoute,
  ProjectProjectIdRoute: ProjectProjectIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
